//import logo from './logo.svg';
import {
  createBrowserRouter,
  RouterProvider,
  // Navigate,
} from "react-router-dom";
import { lazy, Suspense } from "react";

import HomePage from "./pages/HomePage";
//import ArtWorksPage from "./pages/ArtWorksPage";
import AboutPage from "./pages/AboutPage";
//import ProjectsPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactPage";
import RootLayout from "./components/RootLayout";
//import ProjectDetail from "./pages/ProjectDetailPage";

const ArtWorksPage = lazy(() => import("./pages/ArtWorksPage"));
const ProjectsPage = lazy(() => import("./pages/ProjectsPage"));
const ProjectDetail = lazy(() => import("./pages/ProjectDetailPage"));

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      children: [
        {
          index: true,
          element: <HomePage />,
        },
        {
          path: "AboutMe",
          element: <AboutPage />,
        },
        {
          path: "MyProjects",
          element: (
            <Suspense
              fallback={
                <p style={{ textAlign: "center", color: "black" }}>
                  Loading...
                </p>
              }
            >
              <ProjectsPage />
            </Suspense>
          ),
        },
        {
          path: "MyProjects/:id",
          element: (
            <Suspense
              fallback={
                <p style={{ textAlign: "center", color: "black" }}>
                  Loading...
                </p>
              }
            >
              <ProjectDetail />
            </Suspense>
          ),
        },
        {
          path: "MyArtWorks",
          element: (
            <Suspense
              fallback={
                <p style={{ textAlign: "center", color: "black" }}>
                  Loading...
                </p>
              }
            >
              <ArtWorksPage />
            </Suspense>
          ),
        },
        {
          path: "ContactMe",
          element: <ContactPage />,
        },
      ],
    },
  ]);
  return <RouterProvider router={router} />;
}

export default App;
